<div>
    <FlashMessage></FlashMessage>

    <div class="manage-package-block">
        <div class="white-box">

            <div class="sort-wrapper">
                <div class="error-list mb-3" v-if="ui.error.error_message">
                    <ul class="error-msg">
                        <li :key="x" v-for="(error,x) in ui.error.error_message">
                            <div :key="i" v-for="(err,i) in error">
                                <p> {{err}}</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="table-title pl-0">
                    <div class="container-fluid px-0">
                        <div class="row align-items-center">
                            <div class="col-lg-9">
                                <h5>Manage Room</h5>
                            </div>
                            <div class="col-lg-3" v-if="permission.hotel_add_room">
                                <a @click.prevent="createNewRoom" class="btn add-btn" href="#"><i
                                        class="fas fa-plus"></i>&nbsp;Add New Room</a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="table-container">
                <div class="table-responsive">
                    <table class="table" id="example">
                        <thead class="table-light-bg">
                            <tr>
                                <!-- <th scope="col">Photo</th> -->
                                <th scope="col">S.N.</th>
                                <th scope="col">Image</th>
                                <th scope="col">Rom</th>
                                <th scope="col">Bed Type
                                    <!-- <i class="fas fa-chevron-up"></i>
                                  <i class="fas fa-chevron-down"></i> -->
                                </th>

                                <th scope="col">Total Room
                                </th>
                                <!-- <th scope="col">Start time
                              </th> -->
                                <th scope="col">Guest
                                </th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr :key="index" v-for="(room,index) in item.roomList">

                                <td v-if="room.id">{{index+1}}</td>
                                <td>
                                    <div class="activity-image" v-if="room.image != null ">
                                        <img :src="room.image_path" :alt="room.room_type"></div>
                                    <div class="activity-image" v-else><img src="img/noimage.jpg" :alt="room.room_type"></div>

                                </td>
                                <td @click.prevent="editRoomInfo(index ,room)" v-if="room.room_type">{{room.room_type}}</td>
                                <td @click.prevent="editRoomInfo(index ,room)" v-if="room.bed_type">{{room.bed_type}}</td>
                                <td>{{ room.total_room}}</td>
                                <td>{{ room.adult}} Adults, {{ room.child}} Children</td>
                                <td>
                                    <div class="includes-action justify-content-start" v-if="permission.hotel_room_edit">
                                        <button @click.prevent="editRoomInfo(index,room)" class="btn blue" type="button"><i class="fas fa-pen"></i></button>
                                        <!-- <button type="button" class="btn red"><i class="fas fa-trash-alt"></i></button>  -->
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="empty-data" v-if="item.roomList==0">
                        <p>
                            No Room Found
                        </p>
                    </div>
                    <div class="spinner">
                        <moon-loader :loading="ui.status.isLoading.getRoomList" :size="50" v-if="item.roomList"></moon-loader>
                    </div>
                </div>
            </div>
            <Pager :pager="ui.paging" @onPaging="onPaging"></Pager>
        </div>

    </div>
</div>